export const AUTHENTICATION_CLICK_TIMEOUT_BEFORE_NAVIGATING_AWAY = 500
